import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import PageLoader from "./../../../../assets/loading/pageLoad1.gif"

const EditCcPurchase = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [purchase, setPurchase] = useState({})
  const [chillings, setChillings] = useState([])
  const [routes, setRoutes] = useState([])
  const [collections, setCollections] = useState([])
  const [vendors, setVendors] = useState([])
  const [entryMode, setEntryMode] = useState("")

  useEffect(() => { getInfo() }, [])

  const getInfo = async () => {
    try {
      const [recResp, chilResp, rouResp, ccResp, venResp] = await Promise.all([
        api.get("cc-purchase/" + id), api.get("centers?per_page=500"),
        api.get("routes?per_page=500"), api.get("collection-centers?per_page=500"),
        api.get("vendors?per_page=500")
      ])
      const record = recResp.data.data[0] || {}
      setPurchase(record)
      setEntryMode(String(record.entryMode || ""))
      const extract = (r) => { const d = r.data?.data; return Array.isArray(d) ? d : d?.data || [] }
      setChillings(extract(chilResp)); setRoutes(extract(rouResp))
      setCollections(extract(ccResp)); setVendors(extract(venResp))
    } catch (e) { console.error(e) }
    setPageLoad(false)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true); setSubmitted(false)
    try {
      const resp = await api.put("update-cc-purchase/" + id, values)
      if (resp.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 3000) }
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  if (pageLoad) return <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Edit CC Purchase</h4></Col>
          <Col md={6} style={{textAlign:"right"}}><Link to="/cc-purchases" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal" onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px"}}><i className="fas fa-map-marker-alt"></i> Location</h6>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center" required value={String(purchase.chillingCenter||"")}>
              <option value="">Select</option>{chillings.map((c,i)=><option key={i} value={String(c.id)}>{c.name}</option>)}
            </AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="route" label="Route" required value={String(purchase.route||"")}>
              <option value="">Select</option>{routes.map((r,i)=><option key={i} value={String(r.id)}>{r.routeName}</option>)}
            </AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="collectionCenter" label="Collection Center" required value={String(purchase.collectionCenter||"")}>
              <option value="">Select</option>{collections.map((c,i)=><option key={i} value={String(c.id)}>{c.centerName}</option>)}
            </AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="vendor" label="Vendor" value={String(purchase.vendor||"")}>
              <option value="">Select</option>{vendors.map((v,i)=><option key={i} value={String(v.id)}>{v.vendorName||v.name}</option>)}
            </AvField></div></Col>
          </Row>

          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-shopping-cart"></i> Purchase Details</h6>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="purchaseDate" label="Date" type="date" value={purchase.purchaseDate} required /></div></Col>
            <Col md={4}><div className="mb-3"><AvRadioGroup inline name="shift" label="Shift" value={String(purchase.shift)} required errorMessage="Pick one!"><AvRadio label="AM" value="0" /><AvRadio label="PM" value="1" /></AvRadioGroup></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="serialNo" label="Serial No" type="text" value={purchase.serialNo} /></div></Col>
            <Col md={4}><div className="mb-3"><AvRadioGroup inline name="milkType" label="Milk Type" value={String(purchase.milkType)} required errorMessage="Pick one!"><AvRadio label="Cow" value="1" /><AvRadio label="Buffalo" value="2" /><AvRadio label="Common" value="3" /></AvRadioGroup></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="qtyUnit" label="Qty Unit" type="select" value={purchase.qtyUnit}><option value="Ltrs">Liters</option><option value="KG">Kilograms</option></AvField></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="purchaseTime" label="Time" type="time" value={purchase.purchaseTime} /></div></Col>
            <Col md={4}><div className="mb-3"><AvRadioGroup inline name="entryMode" label="Entry Mode" value={String(purchase.entryMode)} required errorMessage="Pick one!" onChange={e=>setEntryMode(e.target.value)}><AvRadio label="SNF" value="1" /><AvRadio label="CLR" value="2" /></AvRadioGroup></div></Col>
          </Row>

          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-flask"></i> Quality</h6>
          <Row>
            <Col md={3}><div className="mb-3"><AvField name="qtyLtrs" label="Ltrs" type="number" step="0.01" value={purchase.qtyLtrs} required validate={{min:{value:0}}} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="qtyKg" label="KG" type="number" step="0.01" value={purchase.qtyKg} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseFat" label="FAT" type="number" step="0.01" value={purchase.purchaseFat} required validate={{min:{value:0},max:{value:15}}} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseSnf" label="SNF" type="number" step="0.01" value={purchase.purchaseSnf} required readOnly={entryMode==="2"} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseClr" label="CLR" type="number" step="0.01" value={purchase.purchaseClr} required readOnly={entryMode==="1"} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="waterPercent" label="Water %" type="number" step="0.01" value={purchase.waterPercent} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseCans" label="Cans" type="number" step="1" value={purchase.purchaseCans} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="temperature" label="Temp" type="number" step="0.1" value={purchase.temperature} /></div></Col>
          </Row>

          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-rupee-sign"></i> Pricing</h6>
          <Row>
            <Col md={3}><div className="mb-3"><AvField name="ratePerLtr" label="Rate/Ltr" type="number" step="0.01" value={purchase.ratePerLtr} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="ratePerKg" label="Rate/KG" type="number" step="0.01" value={purchase.ratePerKg} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="incentive" label="Incentive" type="number" step="0.01" value={purchase.incentive} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="deductions" label="Deductions" type="number" step="0.01" value={purchase.deductions} /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="netAmount" label="Net Amount" type="number" step="0.01" value={purchase.netAmount} /></div></Col>
            <Col md={8}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" rows="2" value={purchase.remarks} /></div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>CC Purchase Updated!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner animation="border" size="sm" /><span style={{paddingLeft:"10px"}}>Updating...</span></> : <span><i className="fas fa-save"></i> Update Purchase</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default EditCcPurchase
